import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const Payments = () => {
  return (
    <Box p={4}>
      <Heading mb={4}>Payments</Heading>
      <Text>Payment management dashboard coming soon...</Text>
    </Box>
  );
};

export default Payments; 